import { render, staticRenderFns } from "./DiffIcon.vue?vue&type=template&id=5553ebcf&scoped=true&"
import script from "./DiffIcon.vue?vue&type=script&lang=js&"
export * from "./DiffIcon.vue?vue&type=script&lang=js&"
import style0 from "./DiffIcon.vue?vue&type=style&index=0&id=5553ebcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5553ebcf",
  null
  
)

export default component.exports